module.exports = __webpack_public_path__ + "static/fonts/Oxanium-Bold.0dd385a2.ttf";